// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1S8Qg","productName":"Table_productName__6W5NF"};